import { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Modal } from "reactstrap";

const EmailViewModal = ({ isOpenEmail, toggleEmail, emailBody }) => {

    // Utility to decode and clean the raw HTML string
    const decodeEmailBody = (htmlString) => {
        if (!htmlString || typeof htmlString !== 'string') return '';

        const decoded = htmlString
            .replace(/\\r\\n/g, '')  // remove literal \r\n
            .replace(/\\n/g, '') // remove literal \n
            .replace(/\\r/g, '') // remove literal \r
            .replace(/\\"/g, '"') // unescape quotes
            .replace(/\\\\/g, '\\'); // unescape backslashes

        return decoded;
    };

    // Utility to extract only <body> content if full HTML doc is passed
    const extractBodyContent = (htmlString) => {
        if (typeof htmlString !== 'string') return;
        const match = htmlString.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
        return match ? match[1] : htmlString;
    };

    const cleanEmailHtml = extractBodyContent(decodeEmailBody(emailBody));

    return (
        <Modal className={`modal-action modal-xl`} isOpen={isOpenEmail} toggle={toggleEmail}>
            <Card className='w-100'>
                <CardHeader tag="h3">
                    Email
                    <Button className='btn float-end' close onClick={toggleEmail} />
                </CardHeader>
                <CardBody>
                    <div
                        dangerouslySetInnerHTML={{ __html: cleanEmailHtml }}
                        style={{ maxHeight: '70vh', overflowY: 'auto' }}
                    />
                    <div className='d-flex justify-content-end mt-3'>
                        <Button className='btn-sm mr-2' color='outline-primary' onClick={toggleEmail}>Cancel</Button>
                    </div>
                </CardBody>
            </Card>
        </Modal>)
}

export default EmailViewModal;
